export function isInt(value) {
    return /^\d+$/i.test(value)
}